function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-calendar{fill:none;}.cls-2-calendar{fill:#c2e0dc;}.cls-3-calendar{fill:#565251;}.cls-4-calendar{fill:#48a9a1;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Warstwa_1-2",
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  className: "cls-1-calendar",
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  className: "cls-2-calendar",
  x: 2.04,
  y: 2.4,
  width: 17.48,
  height: 14.7,
  rx: 0.46
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3-calendar",
  d: "M17.55,3.7H14.84V2a.5.5,0,0,0-.5-.5H12.88a.5.5,0,0,0-.5.5V3.7H6.16V2a.5.5,0,0,0-.5-.5H4.2a.5.5,0,0,0-.5.5V3.7H1a.52.52,0,0,0-.5.5V18a.5.5,0,0,0,.5.5H17.55a.5.5,0,0,0,.5-.48V4.2A.52.52,0,0,0,17.55,3.7Zm-.5,13.78H1.49V4.7H3.7V5.78a.5.5,0,0,0,.5.5H5.66a.5.5,0,0,0,.5-.5V4.7h6.22V5.78a.5.5,0,0,0,.5.5h1.46a.5.5,0,0,0,.5-.5V4.7h2.21Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 3.7,
  y: 11.11,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 12.35,
  y: 11.11,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 3.69,
  y: 8.5,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 8,
  y: 8.5,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 12.34,
  y: 8.5,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 3.69,
  y: 13.71,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 8,
  y: 13.71,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 12.34,
  y: 13.71,
  width: 2.51,
  height: 1.64,
  rx: 0.48
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4-calendar",
  x: 8.01,
  y: 11.11,
  width: 2.51,
  height: 1.64,
  rx: 0.48
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Calendar.deecea7b.svg";
export { ForwardRef as ReactComponent };